import { render, staticRenderFns } from "./CreateSurvey.vue?vue&type=template&id=98797090"
import script from "./CreateSurvey.vue?vue&type=script&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&lang=js"
import style0 from "./CreateSurvey.vue?vue&type=style&index=0&id=98797090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports